import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { createRequestAction } from '~/Helpers/Action.helpers';

export const requestProviderCategoryList = () =>
  createRequestAction({
    name: REQUEST_ACTIONS.PROVIDER_CATEGORY_LIST,
    url: PROVIDER_SERVICE_URLS.CATEGORY_LIST,
    method: 'GET',
  });
